const vario125Data = {
  slug: "vario-125",
  name: "Honda Vario 125 eSP",

  hero: {
    shortDescription:
      "Skutik 125cc modern dengan desain sporty, mesin irit, dan fitur canggih untuk mobilitas harian",

    variants: [
      {
        key: "cbs-sporty-black",
        label: "CBS",
        fullName: "Honda Vario 125 eSP CBS Sporty Black",
        startPrice: 25153000,
      },
      {
        key: "cbs-iss-advance-matte-red",
        label: "CBS ISS",
        fullName: "Honda Vario 125 eSP CBS ISS Advance Matte Red",
        startPrice: 26808000,
      },
      {
        key: "street-black-coral",
        label: "CBS ISS",
        fullName: "Honda Vario 125 eSP Street Black Coral",
        startPrice: 27242000,
      },
    ],

    slides: [
      {
        variantKey: "cbs-sporty-black",
        image: "/assets/motor/produk/vario125/Honda-Vario-125-eSP-CBS-Sporty-Black-1-1024x1002.webp",
        specs: {
          engine: "124,8 cc",
          transmission: "Otomatis V-Matic",
          feature: "PGM-FI",
        },
      },
      {
        variantKey: "cbs-iss-advance-matte-red",
        image: "/assets/motor/produk/vario125/Honda-Vario-125-eSP-CBS-ISS-Advance-Matte-Red-2-1024x1002.webp",
        specs: {
          engine: "124,8 cc",
          transmission: "Otomatis V-Matic",
          feature: "ISS + PGM-FI",
        },
      },
      {
        variantKey: "street-black-coral",
        image: "/assets/motor/produk/vario125/Honda-Vario-125-eSP-Street-Black-Coral-1-1024x1002.webp",
        specs: {
          engine: "124,8 cc",
          transmission: "Otomatis V-Matic",
          feature: "ISS + Smart Key",
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Vario 125 eSP hadir sebagai skutik modern dengan desain tajam dan performa mesin yang efisien.",
      },
      {
        type: "paragraph",
        text:
          "Mesin 125cc berteknologi eSP dan PGM-FI memberikan akselerasi halus serta konsumsi bahan bakar yang irit.",
      },
      {
        type: "heading",
        text: "Desain Sporty & Modern",
      },
      {
        type: "paragraph",
        text:
          "Tampilan agresif dengan lampu LED dan panel meter digital memberikan kesan premium.",
      },
      {
        type: "heading",
        text: "Fitur Lengkap untuk Harian",
      },
      {
        type: "paragraph",
        text:
          "Dilengkapi fitur ISS, Smart Key System, dan bagasi luas untuk menunjang aktivitas sehari-hari.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, SOHC, eSP"],
      ["Kapasitas Mesin", "124,8 cc"],
      ["Sistem Pendingin", "Pendingin Cairan"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "8,2 kW / 8.500 rpm"],
      ["Torsi Maksimum", "10,8 Nm / 5.000 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Lengan Ayun dengan Suspensi Tunggal"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Tromol"],
      ["Sistem Pengereman", "CBS"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.918 x 679 x 1.066 mm"],
      ["Jarak Sumbu Roda", "1.280 mm"],
      ["Tinggi Jok", "769 mm"],
      ["Berat", "111 kg (CBS) / 112 kg (ISS)"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "5,5 Liter"],
      ["Kapasitas Bagasi", "18 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Full Digital"],
      ["Lampu Depan", "LED"],
      ["Tipe Aki", "MF Battery"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Vario 125 eSP",
    items: [
      {
        title: "Mesin 125cc eSP + PGM-FI",
        desc:
          "Efisiensi bahan bakar tinggi dengan performa mesin yang halus.",
      },
      {
        title: "Idling Stop System (ISS)",
        desc:
          "Mesin mati otomatis saat berhenti untuk menghemat bahan bakar (varian tertentu).",
      },
      {
        title: "Smart Key System",
        desc:
          "Sistem keyless dengan alarm & answer back system (varian tertentu).",
      },
      {
        title: "Full Digital Panel Meter",
        desc:
          "Informasi lengkap dan modern untuk kenyamanan berkendara.",
      },
      {
        title: "Full LED Lighting",
        desc:
          "Pencahayaan lebih terang dan tahan lama.",
      },
      {
        title: "Bagasi 18 Liter",
        desc:
          "Ruang penyimpanan luas untuk helm dan barang bawaan.",
      },
    ],
  },
};

export default vario125Data;
